require('./impositionsRow.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const padLeft = require('lodash/string/padLeft');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const Immutable = require('immutable');

// @ core
const { FormattedText, getLanguage, formatText } = require('core/i18n').i18n;

// @ commons
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKHeaderTag } = require('commonsComponents/OKHeaderTag');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');

// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ helpers
const { formatAmountObject, getPlainAmountObject, formatPercentage, formatInterest } = require('utilities/currencyHelper');
const { getImpositionStatus, impositionTextKeyfromStatus } = require('utilities/contactCenter/impositionsHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');

// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { COUNTRIES_CODES: { NL, PT, DE, ES } } = require('constants/countries');

class ImpositionsRow extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getStatus() {
        const { expirationDate, actualDate } = this.props;
        const stringCode = (new Date(expirationDate) <= new Date(actualDate)) ? 'impositionRow-expired' : 'impositionRow-valid';
        const status = formatText(stringCode);
        return <OKHeaderTag value={status} />;
    }

    getStatusCC() {
        const { expirationDate, actualDate, amount } = this.props;
        const immPartialImposition = Immutable.Map({ expirationDate, amount });
        const status = getImpositionStatus(immPartialImposition, actualDate);
        const statusText = formatText(impositionTextKeyfromStatus(status));
        return <OKHeaderTag value={statusText} />;
    }

    renderButtonAction({ url, colSpan = null }) {
        return (
            <OKTableCell className="imposition-row__right-action" colSpan={colSpan}>
                <OKButton
                    modifier="secondary"
                    size="small"
                    to={url}
                >
                    <FormattedText value="impositionRow-toDetails" />
                </OKButton>
            </OKTableCell>
        )
    }

    render() {
        const { expirationDate, id, tae, tin, amount, currency, originCountry, url, isClosed, hasControlActionButtonOverflow } = this.props;
        const statusTag = __CONTACT_CENTER__ ? this.getStatusCC() : this.getStatus();
        const plainAmountObject = getPlainAmountObject({ amount: amount, currency: currency });
        const language = getLanguage();
        let interesCell;
        let renewalCell;

        if (!isClosed) {
            if ([NL, PT, ES, DE].includes(originCountry)){
                const tinFormatted = [ES].includes(originCountry) ? formatPercentage(tin) : formatInterest(tin);
                interesCell = (
                    <OKTableCell className="imposition-row__tae--bold">
                        {tinFormatted}
                    </OKTableCell>
                );
            }else{
                const taeFormatted = formatInterest(tae);
                interesCell = (
                    <OKTableCell className="imposition-row__tae--bold">
                        {taeFormatted}
                    </OKTableCell>
                );
            }
        }

        const impositionRowStatusClassName = contactCenterClassName('imposition-row__status')

        const response = (
            <>
                <OKTableRow className="imposition-row">
                    <OKTableCell>
                        <LabelDate
                            date={expirationDate}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className={impositionRowStatusClassName}>
                        {statusTag}
                    </OKTableCell>
                    <OKTableCell>
                        {padLeft(parseInt(id), 3, '0')}
                    </OKTableCell>
                    {interesCell}
                    {renewalCell}
                    <OKTableCell className="imposition-row__amount--black">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                    {
                        !hasControlActionButtonOverflow && this.renderButtonAction({ url })
                    }
                </OKTableRow>
                {
                    hasControlActionButtonOverflow && (
                        <OKTableRow className="imposition-row">
                            { this.renderButtonAction({ url, colSpan: 5 }) }
                        </OKTableRow>
                    )
                }
            </>
        );

        return response;
    }
}

ImpositionsRow.propTypes = {
    expirationDate: PropTypes.string.isRequired,
    actualDate: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    hasControlActionButtonOverflow: PropTypes.bool,
    tae: PropTypes.number.isRequired,
    tin: PropTypes.number,
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    originCountry: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    isClosed: PropTypes.bool
};

module.exports = ImpositionsRow;
